module.exports = __webpack_public_path__ + "static/okoromah-de60cb4587729c4b606ab685944e1c87.png";